import { Context } from "../../App";
import Creator from "../../components/calculator/Creator";
import Default from "../../components/Header/Default";

function BonusCalculatorCreatorContent() {
  return (
    <>
      <Default />
      <Creator />
    </>
  );
}

export default function BonusCalculatorCreatorPage({ statusMode, setStatusMode }) {
  return (
    <Context.Provider value={{ statusMode, setStatusMode }}>
      <BonusCalculatorCreatorContent />
    </Context.Provider>
  );
}
